const $accordionTitle = $('.js-accordion-revamp').find('.js-accordion-revamp-title');
const allPanels = $('.js-accordion-revamp-panel');

$accordionTitle.on('click', function() {
    const panel = $(this).parent();
    allPanels.not(panel).removeClass('is-active');
    panel.toggleClass('is-active');

    return false;
});